// @ts-nocheck
import { gql } from "@apollo/client";
import { HgFaiDepartment, HgFaiRole, HgProduct } from "../../types/taxonomy";
import FAIByLocationData from "./Installs";

export interface ProductRecord {
  productId: number;
  productName: string;
  signalStrength: number;
}
export interface FAIProductsByDepartmentAndRoleQueryPayload {
  functionalAreaIntelligenceByCompany: {
    data: Array<ProductRecord>;
  };
}

export interface DepartmentTableRecord {
  displayName: string;
  decisionMaker: boolean;
  influencer: boolean;
  usageShare: number;
  department: HgFaiDepartment;
  functionalAreaRole?: HgFaiRole;
  children?: DepartmentTableRecord[];
}

export interface DepartmentRecord {
  decisionMaker: boolean;
  department: string;
  departmentDisplayName: string;
  influencer: boolean;
  productSignalStrength: string;
  functionalAreaRoles?: FunctionalAreaRoleRecord[];
}

export interface FunctionalAreaRoleRecord {
  decisionMaker: boolean;
  functionalAreaRole: string;
  functionalAreaRoleDisplayName: string;
  functionalAreaRoleSignalStrength: number;
  influencer: boolean;
}

export interface FAIDepartmentsByProductQueryPayload {
  functionalAreaIntelligenceByUrl: {
    data: Array<DepartmentRecord>;
  };
}

export interface FAIProductsByCompanyQueryPayload {
  install: {
    count: number;
    data: Array<{
      product: Omit<HgProduct, "description">;
    }>;
  };
}

export const FAI_PRODUCTS_BY_COMPANY_QUERY = gql`
  query faiProductsByCompany(
    $hgId: Identifier!
    $productIds: [Int]
    $productCategoryIds: [Identifier]
    $productAttributeIds: [Int]
    $vendorIds: [Int]
    $countryAlpha2s: [String]
  ) {
    install(
      hgId: $hgId
      productIds: $productIds
      categoryIds: $productCategoryIds
      productAttributeIds: $productAttributeIds
      countryAlpha2s: $countryAlpha2s
      vendorIds: $vendorIds
      per: 1000000 #Arbitrarily high number so all are fetched
    ) {
      count
      data {
        product {
          id
          name
        }
      }
    }
  }
`;

export const FAI_DEPARTMENTS_BY_PRODUCT_WITH_ROLES_QUERY = gql`
  query faiDepartmentsByProductQuery(
    $hgId: Identifier!
    $productId: Int
    $productCategoryIds: [Identifier]
    $countryAlpha2s: [String]
    $page: Int
    $per: Int
  ) {
    functionalAreaIntelligenceByUrl(
      hgId: $hgId
      productId: $productId
      productCategoryIds: $productCategoryIds
      countryAlpha2s: $countryAlpha2s
      page: $page
      per: $per
      productSignalStrength: 1
      sorts: [{ field: PRODUCT_SIGNAL_STRENGTH, direction: DESC }]
    ) {
      data {
        decisionMaker
        department
        departmentDisplayName
        influencer
        productSignalStrength
        functionalAreaRoles {
          functionalAreaRole
          functionalAreaRoleDisplayName
          decisionMaker
          influencer
          functionalAreaRoleSignalStrength
        }
      }
    }
  }
`;

export const FAI_PRODUCTS_BY_DEPARTMENT_AND_ROLE_QUERY = gql`
  query faiProductsByDepartmentAndRole(
    $hgId: Identifier!
    $departmentId: Identifier
    $roleId: Identifier
    $vendorIds: [Int]
    $productIds: [Int]
    $productCategoryIds: [Identifier]
    $productAttributeIds: [Int]
    $countryAlpha2s: [String]
    $page: Int
    $per: Int
  ) {
    functionalAreaIntelligenceByCompany(
      hgId: $hgId
      departmentId: $departmentId
      roleId: $roleId
      vendorIds: $vendorIds
      productIds: $productIds
      productCategoryIds: $productCategoryIds
      productAttributeIds: $productAttributeIds
      countryAlpha2s: $countryAlpha2s
      page: $page
      per: $per
      sort: [{ field: SIGNAL_STRENGTH, direction: DESC }]
    ) {
      data {
        productId
        productName
        signalStrength
      }
    }
  }
`;

export const FAI_LOCATION_QUERY = gql`
  query functionalIntelligenceByLocation(
    $hgId: Identifier!
    $department: String!
    $functionalAreaRole: String
    $productId: Int!
    $per: Int!
  ) {
    functionalIntelligenceByLocation(
      hgId: $hgId
      department: $department
      functionalAreaRole: $functionalAreaRole
      productId: $productId
      per: $per
    ) {
      data {
        lastVerified
        firstVerified
        signalStrength
        city
        state
        country
        decisionMaker
        influencer
        decisionMakerTitles
        influencerTitles
        totalLocationCount
      }
      count
    }
  }
`;
